
/**
 * Module dependencies.
 */

import { availableFiltersKeys } from 'src/core/ambients-config/filters';
import ApplicationFilter from 'src/components/collections/filters-list/application-filter';
import BaseFiltersSidebar from 'src/components/filters/filters-sidebar';
import EffectFilter from 'src/components/collections/filters-list/effect-filter';
import React, { ReactElement } from 'react';

/**
 * `Props` type.
 */

type Props = {
  isOpen: boolean,
  isUpdating: boolean,
  onClose: () => void,
  onUpdate: () => void
}

/**
 * `FiltersSidebar` component.
 */

const FiltersSidebar = (props: Props): ReactElement => {
  const { isOpen, isUpdating, onClose, onUpdate } = props;

  return (
    <BaseFiltersSidebar
      isOpen={isOpen}
      isUpdating={isUpdating}
      onClose={onClose}
      onUpdate={onUpdate}
    >
      <ApplicationFilter filterName={availableFiltersKeys.application} />

      <EffectFilter filterName={availableFiltersKeys.effect} />
    </BaseFiltersSidebar>
  );
};

/**
 * Export `FiltersSidebar` component.
 */

export default FiltersSidebar;
